<template>
<div class="col backgroundForm">
    <div class="col-md-6 offset-md-3">
        <div class="alert alert-info" align="center" role="alert">
            <h4 class="alert-heading">Administracion de Personas u Empresas</h4>
            <p>Registro, Actualizacion de datos de Propietarios u Empresas</p>        
        </div>
    </div>
    
    <nav>
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
            <a class="nav-item nav-link active" id="nav-capitan-list" data-toggle="tab" href="#new-owner" role="tab" aria-controls="nav-capitan" aria-selected="true"><font-awesome-icon icon="plus" /> Registrar Datos</a>
            <a class="nav-item nav-link" id="nav-add-capitan" data-toggle="tab" href="#nav-update-owner" role="tab" aria-controls="nav-new" aria-selected="false"><font-awesome-icon icon="user-plus" /> Actualizar Datos</a>
        </div>
    </nav>
            
    <div class="tab-content" id="nav-tabContent">                
        <div class="tab-pane fade show active" id="new-owner" role="tabpanel" aria-labelledby="nav-capitan-tab">
            <br><br>
            <div class="form-row">
                        <div class="form-group col-12 col-md-4">
                            <label for="type_identification" class="badge badge-primary">Tipo Identificacion</label>
                            <select class="form-control" name="type_ship" v-model="owner.type_identification" :disabled="d_owner_disabled" @change="mChangeOwnerIdentification">
                                <option v-for="identification in types_identification" :value="identification.id" :key="identification.id">{{ identification.detail }}</option>
                            </select>
                        </div>

                        <div class="form-group col-12 col-md-4">
                            <label for="number_identification" class="badge badge-primary">Numero Identificacion </label>
                            <input type="text" class="form-control" v-model="owner.number_identification" name="number_identification" placeholder="Numero de Identificacion" :disabled="d_owner_disabled" autocomplete="off">
                        </div>

                        <div class="form-group col-12 col-md-4">
                            <label for="site_expedition" class="badge badge-primary">Lugar Emision </label>
                            <select class="form-control" name="site_expedition" v-model="owner.site_expedition" :disabled="d_owner_disabled">
                                <option v-for="city in citys" :value="city.id" :key="city.id">{{ city.detail }}</option>
                            </select>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col-12 col-md-6">
                            <label for="owner_name" class="badge badge-primary">Nombre Propietario</label>
                            <input type="text" class="form-control" v-model="owner.name" name="owner_name" placeholder="Nombre Propietario" autocomplete="off" :disabled="d_owner_disabled">
                        </div>

                        <div class="form-group col-12 col-md-6">
                            <label for="owner_direction" class="badge badge-primary">Direccion </label>
                            <input type="text" class="form-control" v-model="owner.direction" name="owner_direction" placeholder="Direccion" autocomplete="off" :disabled="d_owner_disabled">
                        </div>
                    </div>

                    <div class="form-row">

                        <div class="form-group col-12 col-md-6">
                            <label for="owner_celular" class="badge badge-primary">Celular </label>
                            <input type="number" class="form-control" v-model="owner.mobile" name="owner_celular" placeholder="Celular" autocomplete="off" :disabled="d_owner_disabled">
                        </div>

                        <div class="form-group col-12 col-md-6">
                            <label for="phone_static" class="badge badge-primary">Telefono Fijo </label>
                            <input type="number" class="form-control" v-model="owner.phone" name="phone_static" placeholder="Telefono Fijo" autocomplete="off" :disabled="d_owner_disabled">
                        </div>
                    </div>
                    
                    <div class="form-row">

                        <div class="form-group col-12 col-md-6">
                            <label for="owner_partner" class="badge badge-primary">Representante Legal </label>
                            <input type="text" class="form-control" v-model="owner.partner" name="owner_partner" placeholder="Representante Legal" autocomplete="off" :disabled="d_disabled_partner">
                        </div>

                        <div class="form-group col-12 col-md-6">
                            <label for="owner_nationality" class="badge badge-primary">Nacionalidad </label>
                            <select class="form-control" name="site_expedition" v-model="owner.nationality" :disabled="d_owner_disabled">
                                <option v-for="country in countrys" :value="country.id" :key="country.id">{{ country.detail }}</option>
                            </select>
                        </div>
                    </div>
            <br>
            <button class="btn btn-outline-info col-12 col-md-2 offset-md-5" @click="mRegisterPerson">
                <font-awesome-icon icon="save" size="2x" /> Registrar
            </button>

        </div>
        <!-- end first tab -->

        <!-- tab de edicion de la persona u empresa -->
        <div class="tab-pane fade" id="nav-update-owner" role="tabpanel" aria-labelledby="nav-new-tab" >
            <br>
                    
                    <h6 align="center">Busqueda y Edicion de Propietario(s)</h6>
                    <hr>
                    <!-- embarcacion encontrada -->
                    <transition name="fade" mode="out-in">

                    <div v-if="person_edit.id > 0" class="panel panel-default">
                        <div class="form-row">
                        <div class="form-group col-12 col-md-4">
                            <label for="type_identification" class="badge badge-primary">Tipo Identificacion</label>
                            <select class="form-control" name="type_ship" v-model="person_edit.type_identification" :disabled="d_owner_disabled_edit" @change="mChangeOwnerIdentificationEdit">
                                <option v-for="identification in types_identification" :value="identification.id" :key="identification.id">{{ identification.detail }}</option>
                            </select>
                        </div>

                        <div class="form-group col-12 col-md-4">
                            <label for="number_identification" class="badge badge-primary">Numero Identificacion </label>
                            <input type="text" class="form-control" v-model="person_edit.number_identification" name="number_identification" placeholder="Numero de Identificacion" :disabled="d_owner_disabled_edit" autocomplete="off">
                        </div>

                        <div class="form-group col-12 col-md-4">
                            <label for="site_expedition" class="badge badge-primary">Lugar Emision </label>
                            <select class="form-control" name="site_expedition" v-model="person_edit.site_expedition" :disabled="d_owner_disabled">
                                <option v-for="city in citys" :value="city.id" :key="city.id">{{ city.detail }}</option>
                            </select>
                        </div>
                    </div>

                    <div class="form-row">
                        <div class="form-group col-12 col-md-6">
                            <label for="owner_name" class="badge badge-primary">Nombre Propietario</label>
                            <input type="text" class="form-control" v-model="person_edit.name" name="owner_name" placeholder="Nombre Propietario" autocomplete="off" :disabled="d_owner_disabled">
                        </div>

                        <div class="form-group col-12 col-md-6">
                            <label for="owner_direction" class="badge badge-primary">Direccion </label>
                            <input type="text" class="form-control" v-model="person_edit.direction" name="owner_direction" placeholder="Direccion" autocomplete="off" :disabled="d_owner_disabled">
                        </div>
                    </div>

                    <div class="form-row">

                        <div class="form-group col-12 col-md-6">
                            <label for="owner_celular" class="badge badge-primary">Celular </label>
                            <input type="number" class="form-control" v-model="person_edit.mobile" name="owner_celular" placeholder="Celular" autocomplete="off" :disabled="d_owner_disabled">
                        </div>

                        <div class="form-group col-12 col-md-6">
                            <label for="phone_static" class="badge badge-primary">Telefono Fijo </label>
                            <input type="number" class="form-control" v-model="person_edit.phone" name="phone_static" placeholder="Telefono Fijo" autocomplete="off" :disabled="d_owner_disabled">
                        </div>
                    </div>
                    
                    <div class="form-row">

                        <div class="form-group col-12 col-md-6">
                            <label for="owner_partner" class="badge badge-primary">Representante Legal </label>
                            <input type="text" class="form-control" v-model="person_edit.partner" name="owner_partner" placeholder="Representante Legal" autocomplete="off" :disabled="d_disabled_partner_edit">
                        </div>

                        <div class="form-group col-12 col-md-6">
                            <label for="owner_nationality" class="badge badge-primary">Nacionalidad </label>
                            <select class="form-control" name="site_expedition" v-model="person_edit.nationality" :disabled="d_owner_disabled">
                                <option v-for="country in countrys" :value="country.id" :key="country.id">{{ country.detail }}</option>
                            </select>
                        </div>
                    </div>
                        <button class="btn btn-info col-12 col-md-2 offset-md-4" @click="mUpdatePerson"><font-awesome-icon icon="sync-alt" size="2x" /></button>
                        <button class="btn btn-danger col-12 col-md-2" @click="mCloseEdit"><font-awesome-icon icon="times-circle" size="2x" /></button>
                    </div>

                    <!-- busqueda de embarcacion -->
                    <div v-else>
                        <div class="btn-group btn-group-toggle" data-toggle="buttons">
                            <label class="btn btn-success active" @click="mViewSearch">
                                <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" v-model="optionSearch"  value="document" checked> Nombre 
                            </label>
                            <label class="btn btn-success" @click="mViewSearch">
                                <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios2" v-model="optionSearch" value="name">No. Documento
                            </label>
                        </div>

                        <div class="form-group"> 
                            <label for="nombreEmbarcacion">{{ searchType }}</label>
                            <input type="text" class="form-control" id="data_person" v-model="data_person" :placeholder="searchType" autocomplete="off">
                            <small id="enrollmentHelp" class="form-text text-muted">Teclee {{ searchType }} </small>
                        </div>
                    <button class="btn btn-lg btn-outline-primary col col-md-4 offset-md-4" @click="buscaData">Buscar</button>

                        <div class="table-responsive" v-if="list_person_edit.length > 0">
                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Nombre Completo</th>
                                        <th>CI / NIT</th>
                                        <th><font-awesome-icon icon="check"/></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(persReg, index) in list_person_edit" :key="persReg.id">
                                        <td>{{ index+1 }}</td>
                                        <td>
                                            <span>{{ persReg.nombre_propietario }}</span>
                                        </td>
                                        <td>{{ persReg.dato_identificacion }}</td>
                                        <td>
                                            <button class="btn btn-outline-info" @click="mSelectPersonEdit(persReg)">
                                                <font-awesome-icon icon="check"/>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    </transition>
            </div>

    </div>
    <modal-loading :id-modal="modal_load_id" :title="modal_load_title" :status-send="status_send"></modal-loading>
</div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import modalLoading from '../modal/modalLoading';
const qs = require('qs');

export default {
    name:'admin-user',
    data(){
        return{
           owner:{
                id:0,
                type_identification:null,
                number_identification:null,
                site_expedition:null,
                name:null,
                direction:null,
                mobile:null,
                phone:null,
                partner:null,
                nationality:null
            },
            person_edit:{
                id:0,
                type_identification:null,
                number_identification:null,
                site_expedition:null,
                name:null,
                direction:null,
                mobile:null,
                phone:null,
                partner:null,
                nationality:null
            },
            list_person_edit:[],
            d_owner_disabled:false,
            d_disabled_partner:false,
            d_owner_disabled_edit:false,
            d_disabled_partner_edit:false,
            types_identification:[],
            citys:[],
            countrys:[],
            status_send:true,
            modal_load_id:'id_owner_new',
            modal_load_title:'Cargando', 
            optionSearch:'name',
            data_person:null
        }
    },
    mounted(){
        // if(Vue.auth.getToken()){
        //     axios.defaults.headers.common['Authorization']=`Bearer ${Vue.auth.getToken()}`;
        // }
        // console.log(axios.defaults.headers)
        this.mCallIdentifications(),
        this.mCallCitys(),
        this.mCallCountrys()
    },
    methods:{
        mValidateUpdateOwner(){
            if(this.person_edit.type_identification===0 || this.person_edit.type_identification===null ){
                toastr.error('Indique un tipo de identificacion','Tipo Identificacion');
                return false;
            }
            if(this.person_edit.number_identification ===null || this.person_edit.number_identification.trim().length === 0 ){
                toastr.error('Indique un numero de identificacion','Numero Identificación');
                return false;
            }
            if(this.person_edit.site_expedition === null || this.person_edit.site_expedition === 0){
                toastr.error('Indique un sitio de expedicion','Sitio Expedición');
                return false;
            }
            if(this.person_edit.name === null || this.person_edit.name.trim().length === 0){
                toastr.error('Indique el nombre del propietario','Nombre');
                return false;
            }
            if( this.person_edit.direction===null || this.person_edit.direction.trim().length === 0 ){
                toastr.error('Indique una Direccion del Propietario','Dirección');
                return false;
            }
            if( this.person_edit.mobile===null || this.person_edit.mobile.trim().length === 0 ){
                toastr.error('Indique un telefono movil','Movil');
                return false;
            }
            console.log(this.d_disabled_partner_edit);
            if(!this.d_disabled_partner_edit){
                if( this.person_edit.partner === null || this.person_edit.partner.trim().length === 0){
                    toastr.error('Indique un representante legal','Representante');
                    return false;
                }
            }                
            if( this.person_edit.nationality ===null || this.person_edit.nationality === 0){
                toastr.error('Indique la Nacionalidad del Propietario u Armador','Nacionalidad');
                return false;
            }
            return true;
        },
        mUpdatePerson(){
            if(this.mValidateUpdateOwner()){

                let propietario={
                    id_propietario:this.person_edit.id,
                    t_idenficacion:parseInt(this.person_edit.type_identification),
                    n_identificacion:this.person_edit.number_identification,
                    expedido:parseInt(this.person_edit.site_expedition),
                    nombre_propietario:this.person_edit.name,
                    direccion:this.person_edit.direction,
                    celular:parseInt(this.person_edit.mobile),
                    telefono:parseInt(this.person_edit.phone),
                    representante:this.person_edit.partner,
                    nacionalidad:parseInt(this.person_edit.nationality)
                }
                let param={
                        owner_ship:JSON.stringify(propietario)
                }

                axios.post(`insertOwnerData?api_token=${Vue.auth.getToken()}`,
                                    qs.stringify(param))
                        .then(res=>{
                            console.log(res);
                            if(res.data.status){
                                toastr.success(`${res.data.respuesta}`,'Error');
                                setTimeout(()=>{
                                    // this.mCloseProgressModal();
                                    this.list_person_edit=[];
                                    this.mCloseEdit()
                                }, 2000);
                            }else{
                                toastr.error(`${res.data.respuesta}`,'Error');
                            }
                            
                            
                        }).catch(error => {
                            setTimeout(()=>{
                                this.mCloseProgressModal();
                                toastr.error('Error consulte al administrador','Error');
                            }, 3000);
                            console.log(error)
                        })
            }else{
                console.log(`Solucione los errores indicados`);
            }
        },  
        mCloseEdit(){
            this.person_edit.id=0;
            this.person_edit.type_identification=0;
            this.person_edit.number_identification=0;
            this.person_edit.site_expedition=0;
            this.person_edit.name=null;
            this.person_edit.direction=null;
            this.person_edit.mobile=null;
            this.person_edit.phone=null;
            this.person_edit.partner=null;
            this.person_edit.nationality=0;
        },
        mSelectPersonEdit(sp){
            this.person_edit.id=sp.id_propietario;
            this.person_edit.type_identification=sp.tipo_identificacion;
            this.person_edit.number_identification=sp.dato_identificacion;
            this.person_edit.site_expedition=sp.id_expedido;
            this.person_edit.name=sp.nombre_propietario;
            this.person_edit.direction=sp.domicilio;
            this.person_edit.mobile=sp.celular;
            this.person_edit.phone=sp.telefono_fijo;
            this.person_edit.partner=sp.representante_legal;
            this.person_edit.nationality=sp.id_nacionalidad;
            this.mChangeOwnerIdentificationEdit();
        },
        buscaData(){
            // console.log(`${this.optionSearch} tipo`);
            // console.log(`${this.data_person}`);
            if(this.data_person !== null || this.data_person.trim().length > 0 ){
                console.log('enviando al servidor');
                axios.get(`searchOwnerType/${this.data_person}/${this.optionSearch}?api_token=${Vue.auth.getToken()}`)
                    .then((res) => {                    
                        this.list_person_edit = res.data
                        // this.users = res.data.items
                    }).catch(error => {
                        console.log(error);
                    })
            }else{
                toastr.warning('Indique un valor de busqueda', 'Dato Busqueda');
            }
        },
        mViewSearch(event){
            console.log(event);
            var radios=$("input[type=radio]").parents('label');
            let radioV;                
                for(let i=0;i<radios.length;i++){                    
                    if($(radios[i]).hasClass('active')){
                        radioV=$(radios[i]).children('input').attr('value');
                    }
                }
            //console.log(radioV);
            this.optionSearch=radioV;
        },
        mProgressModal(){
            $('#'+this.modal_load_id).modal('show');
        },
        mCloseProgressModal(){
            $('#'+this.modal_load_id).modal('hide');
        },
        mCallCountrys(){
            // axios.get(`globals/country`)
            axios.get(`globals/country?api_token=${Vue.auth.getToken()}`)
            .then(res => {                
                this.countrys=res.data
            })
        },
        mCallCitys(){
            // axios.get(`globals/citys`)
            axios.get(`globals/citys?api_token=${Vue.auth.getToken()}`)
            .then(res => {                
                this.citys=res.data
            })
        },
        mCallIdentifications(){
            // axios.get(`globals/ident`)
            axios.get(`globals/ident?api_token=${Vue.auth.getToken()}`)
            .then(res => {                
                this.types_identification=res.data
            })
        },
        mValidateRegOwner(){
            if(this.owner.type_identification===0 || this.owner.type_identification===null ){
                toastr.error('Indique un tipo de identificacion','Tipo Identificacion');
                return false;
            }
            if(this.owner.number_identification ===null || this.owner.number_identification.trim().length === 0 ){
                toastr.error('Indique un numero de identificacion','Numero Identificación');
                return false;
            }
            if(this.owner.site_expedition === null || this.owner.site_expedition === 0){
                toastr.error('Indique un sitio de expedicion','Sitio Expedición');
                return false;
            }
            if(this.owner.name === null || this.owner.name.trim().length === 0){
                toastr.error('Indique el nombre del propietario','Nombre');
                return false;
            }
            if( this.owner.direction===null || this.owner.direction.trim().length === 0 ){
                toastr.error('Indique una Direccion del Propietario','Dirección');
                return false;
            }
            if( this.owner.mobile===null || this.owner.mobile.trim().length === 0 ){
                toastr.error('Indique un telefono movil','Movil');
                return false;
            }
            console.log(this.d_disabled_partner);
            if(!this.d_disabled_partner){
                if( this.owner.partner === null || this.owner.partner.trim().length === 0){
                    toastr.error('Indique un representante legal','Representante');
                    return false;
                }
            }                
            if( this.owner.nationality ===null || this.owner.nationality === 0){
                toastr.error('Indique la Nacionalidad del Propietario u Armador','Nacionalidad');
                return false;
            }
            return true;
        },
        mSelectedOwner(data){
            // console.log(data);
            this.owner.id=data.id_propietario;
            this.owner.type_identification=data.tipo_identificacion;
            this.owner.number_identification=data.dato_identificacion;
            this.owner.site_expedition=data.id_expedido;
            this.owner.name=data.nombre_propietario;
            this.owner.direction=data.domicilio;
            this.owner.mobile=data.celular;
            this.owner.phone=data.telefono_fijo;
            this.owner.partner=data.representante_legal;
            this.owner.nationality=data.id_nacionalidad;
            this.d_owner_disabled=true;
            this.d_disabled_partner=true;
        },
        mResetRegisterOwner(){
            this.owner.id=0;
            this.owner.type_identification=null;
            this.owner.number_identification=null;
            this.owner.site_expedition=null;
            this.owner.name=null;
            this.owner.direction=null;
            this.owner.mobile=null;
            this.owner.phone=null;
            this.owner.partner=null;
            this.owner.nationality=null;
            this.d_owner_disabled=false;
            this.d_disabled_partner=false;
        },
        mChangeOwnerIdentification(){            
            switch(this.owner.type_identification){
                case 17:
                // cedula identidad
                    this.d_disabled_partner=true;
                break;

                case 18:
                // nit
                    this.d_disabled_partner=false;
                break;
            }
        },
        mChangeOwnerIdentificationEdit(){
            console.log(this.person_edit.type_identification);            
            switch(this.person_edit.type_identification){
                case 17:
                // cedula identidad
                    this.d_disabled_partner_edit=true;
                break;

                case 18:
                // nit
                    this.d_disabled_partner_edit=false;
                break;
            }
        },
        mRegisterPerson(){
            if(this.mValidateRegOwner()){

                let propietario={
                    id_propietario:this.owner.id,
                    t_idenficacion:parseInt(this.owner.type_identification),
                    n_identificacion:this.owner.number_identification,
                    expedido:parseInt(this.owner.site_expedition),
                    nombre_propietario:this.owner.name,
                    direccion:this.owner.direction,
                    celular:parseInt(this.owner.mobile),
                    telefono:parseInt(this.owner.phone),
                    representante:this.owner.partner,
                    nacionalidad:parseInt(this.owner.nationality)
                }
                let param={
                        owner_ship:JSON.stringify(propietario)
                }

                axios.post(`insertOwnerData?api_token=${Vue.auth.getToken()}`,
                                    qs.stringify(param))
                        .then(res=>{
                            console.log(res);
                            if(res.data.status){
                                toastr.success(`${res.data.respuesta}`,'Error');
                                setTimeout(()=>{
                                    this.mCloseProgressModal();
                                    this.mResetRegisterOwner();
                                }, 2000);
                            }else{
                                toastr.error(`${res.data.respuesta}`,'Error');
                            }
                            
                            
                        }).catch(error => {
                            setTimeout(()=>{
                                this.mCloseProgressModal();
                                toastr.error('Error consulte al administrador','Error');
                            }, 3000);
                            console.log(error)
                        })
            }else{
                console.log(`Solucione los errores indicados`);
            }
        },
    },
    components:{
        'modal-loading':modalLoading
    },
    computed:{
        searchType(){
            switch(this.optionSearch){
                case 'name':
                    return 'Nombre de la Persona';
                break;

                case 'document':
                    return 'Documento de la Persona';
                break;
            }
        }
    },
    filters:{
        upperCase(value){
            return value.toUpperCase();
        }
    }
}
</script>

<style>
    .required-text{
        color:red; 
        font-weight:bold;
    }
</style>



// WEBPACK FOOTER //
// src/components/matriculacion/UpdateOwner.vue